import { render, staticRenderFns } from "./CooperativeMenuIcon.vue?vue&type=template&id=7be53846"
import script from "./CooperativeMenuIcon.vue?vue&type=script&lang=js"
export * from "./CooperativeMenuIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports